import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import NavigationHelper from 'yoda-core-components/lib/helpers/NavigationHelper/NavigationHelper';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { Link } from '../Link/Link';
import {
    commonAutomationIds,
    bannerAutomationIds,
    hero3BannerAutomationIds,
} from '../CoreMediaPage/CMPage.config';

const HeroImage = (props) => {
    const { isMobile, isTablet } = useSelector(
        ({ context: { deviceType = {} } = {} }) => deviceType
    );
    const isSmallTablet = !__SERVER__ && isTablet && window.innerWidth <= 767;
    const [isImageError, setIsImageError] = useState(false);
    const isPrimary = get(props, 'isPrimary', true);
    const imageURL = get(props, 'media[0].fullyQualifiedUrl', '');
    const mediaId = get(props, 'media[0].id', '');
    const alt = get(props, 'media[0].alt', '');
    const cta = get(props, 'ctaLinks[0]', {});
    const isImageLink = !isEmpty(get(cta, 'urlHolder.value', ''));
    const messageLockUpAlignment = get(props, 'messageLockUpAlignment', 'left').includes('left')
        ? 'left'
        : 'right';
    let returnValue = null;
    const canvasRef = useRef(null);
    const navigateToLinks = (event, url, dataItem) => {
        event.preventDefault();
        const openLinkInNewTab = get(dataItem, 'openInNewTab', '');
        return !__SERVER__ ? NavigationHelper.navigate(url, openLinkInNewTab) : '';
    };
    /* istanbul ignore next */
    const cropImageForMobile = (imageProperties) => {
        // crop the image and draw it to the canvas
        const cropImage = (imagePath, newX, newY, newWidth, newHeight) => {
            // create an image object from the path
            const originalImage = new Image();
            originalImage.src = imagePath;
            // initialize the canvas object
            const canvas = canvasRef?.current;
            const ctx = canvas.getContext('2d');
            // wait for the image to finish loading
            originalImage.addEventListener('load', function () {
                // set the canvas size to the new width and height
                canvas.width = newWidth;
                canvas.height = newHeight;
                // draw the image
                ctx.drawImage(
                    originalImage,
                    newX,
                    newY,
                    newWidth,
                    newHeight,
                    0,
                    0,
                    newWidth,
                    newHeight
                );
            });
        };
        const imagePath = imageProperties.src;
        const imageHeight = imageProperties.height;
        const imageWidth = imageProperties.width;
        let sx = 0;
        const sy = 0;
        let cropWidth = 0;
        let cropHeight = 0;
        switch (messageLockUpAlignment) {
            case 'right':
                if (imageWidth > imageHeight) {
                    cropWidth = imageHeight;
                    cropHeight = imageHeight;
                } else {
                    cropWidth = imageWidth;
                    cropHeight = imageWidth;
                }
                break;
            case 'left':
                if (imageWidth > imageHeight) {
                    cropWidth = imageHeight;
                    cropHeight = imageHeight;
                } else {
                    cropWidth = imageWidth;
                    cropHeight = imageWidth;
                }
                sx = imageWidth - imageHeight;
                break;
            default:
                break;
        }
        cropImage(imagePath, sx, sy, cropHeight, cropWidth);
    };
    useEffect(() => {
        if (isMobile || isSmallTablet) {
            const img = new Image();
            /* istanbul ignore next */
            img.onload = function () {
                const imageProperties = {
                    width: this.width,
                    height: this.height,
                    src: this.src,
                    messageLockUpAlignment,
                };
                cropImageForMobile(imageProperties);
            };
            img.src = imageURL;
        }
    }, []);
    const heroTypeStyles = ['smOnly:h-full', 'smOnly:w-full', 'smOnly:aspect-square'];
    const linkAutomationId = isPrimary
        ? commonAutomationIds?.IMAGELINK
        : hero3BannerAutomationIds?.IMAGELINK;
    const imageAutomationId = isPrimary ? commonAutomationIds?.IMAGE : bannerAutomationIds?.IMAGE;
    /* istanbul ignore else */
    if (!isMobile && !isSmallTablet && imageURL) {
        returnValue = isImageLink ? (
            <Link
                href={cta?.urlHolder?.value}
                openLinkInNewTab={cta?.urlHolder?.openInNewTab}
                onClick={(event) => {
                    navigateToLinks(event, cta?.urlHolder?.value, cta?.urlHolder);
                }}
                data-automation-id={linkAutomationId}
            >
                <img
                    src={imageURL}
                    alt={alt}
                    onError={() => {
                        setIsImageError(true);
                    }}
                    data-automation-id={imageAutomationId}
                    className={
                        isImageError
                            ? dt([
                                  'w-full',
                                  props?.heroType === 'primary' ? 'h-[500px]' : 'h-[250px]',
                              ])
                            : dt(['w-full', 'h-full'])
                    }
                />
            </Link>
        ) : (
            <img
                src={imageURL}
                alt={alt}
                onError={() => {
                    setIsImageError(true);
                }}
                data-automation-id={imageAutomationId}
                className={
                    isImageError
                        ? dt(['w-full', props?.heroType === 'primary' ? 'h-[500px]' : 'h-[250px]'])
                        : dt(['w-full', 'h-full'])
                }
            />
        );
    } else if (imageURL) {
        returnValue = isImageLink ? (
            <Link
                href={cta?.urlHolder?.value}
                openLinkInNewTab={cta?.urlHolder?.openInNewTab}
                onClick={(event) => {
                    navigateToLinks(event, cta?.urlHolder?.value, cta?.urlHolder);
                }}
                data-automation-id={linkAutomationId}
            >
                <canvas
                    id="canvas"
                    ref={canvasRef}
                    className={dt([...heroTypeStyles])}
                    data-automation-id={imageAutomationId}
                />
            </Link>
        ) : (
            <canvas
                id="canvas"
                ref={canvasRef}
                className={dt([...heroTypeStyles])}
                data-automation-id={imageAutomationId}
            />
        );
    } else {
        returnValue = null;
    }
    return returnValue;
};

export default HeroImage;
